































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import AnxLink from "../AnxLink/AnxLink.vue";
import VueI18n from "vue-i18n";

/**
 * This component is a simple implementation of a language switcher in combination with Vue-I18n
 */
@Component({
  components: {
    AnxLink
  }
})
export default class I18nLangSwitcher extends Vue {
  /** The i18n instance from the root vue project */
  @Prop({ required: true }) i18n!: VueI18n;

  /**
   * With this property, the different languages that
   * will be selectable in the language switcher can
   * be set
   */
  @Prop({
    default: () => {
      return [
        {
          code: "de",
          link: null,
          text: "DE"
        },
        {
          code: "en",
          link: null,
          text: "EN"
        }
      ];
    }
  })
  languages!: Array<{}>;

  /** Emit the changes languages as @localeChange event */
  @Emit("localeChange")
  setLocale(locale: string) {
    /** Set the locale in the property */
    this.locale = locale;

    /** Set the locale for the i18n instance if provided */
    if (this.i18n !== null) {
      this.i18n.locale = locale;
    }

    return locale;
  }

  /** The current locale */
  private locale = "";

  /** Sync the current locale with the i18n locale on mount */
  private mounted() {
    if (this.i18n) {
      this.locale = this.i18n.locale;
    }
  }
}
